/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import * as navActions from '../../../store/reducers/nav/header/actions';
import * as userAuthActions from '../../../store/reducers/auth/user/actions';
import Footer from '../../../components/organisms/Footer';
var actions = [navActions, userAuthActions];

function mapDispatchToProps(dispatch) {
  var _Map;

  var creators = (_Map = Map()).merge.apply(_Map, actions).filter(function (value) {
    return typeof value === 'function';
  }).toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch: dispatch
  };
}

function mapStateToProps(state) {
  return {
    nav: state.nav,
    user: state.user,
    shoppingCart: state.shoppingCart
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer);